import generateApiClient from "../helpers/generateApiClient";
import getErrorMessage from "../helpers/getErrorMessage";

import {
  FETCH_IMAGES_SUCCESS,
  FETCH_IMAGES_FAILURE,
  IMAGES_SAVE_SUCCESS,
  IMAGES_SAVE_FAILURE,
  IMAGE_ARCHIVE_SUCCESS,
  IMAGE_ARCHIVE_FAILURE,
} from "../constants/imageConstants";
import { push } from "react-router-redux";

const fetchSuccess = (data) => ({ type: FETCH_IMAGES_SUCCESS, data });
const fetchFailure = (error) => ({ type: FETCH_IMAGES_FAILURE, error });

const saveSuccess = (data) => ({ type: IMAGES_SAVE_SUCCESS, data });
const saveFailure = (error) => ({ type: IMAGES_SAVE_FAILURE, error });

const imageArchiveSuccess = (data) => ({ type: IMAGE_ARCHIVE_SUCCESS, data });
const imageArchiveFailure = (error) => ({ type: IMAGE_ARCHIVE_FAILURE, error });

export function fetch() {
  return (dispatch, getState) => {
    const client = generateApiClient(getState);
    return client
      .get("/api/v1/images_generation")
      .then((response) => {
        dispatch(fetchSuccess(response?.data));
      })
      .catch((error) => {
        dispatch(fetchFailure(getErrorMessage(error)));
      });
  };
}

export function save(images, setLoading, navigate) {
  return (dispatch, getState) => {
    setLoading(true);
    const client = generateApiClient(getState);
    if (images.id === "new") {
      return client
        .post("/api/v1/images_generation", { data: images.data })
        .then((response) => {
          const redirect = `/images/${response.data.id}`;
          if (window && window.usermaven && response && response.data) {
            const params = {
              userId: response.data?.owner_id,
              slug: response.data?.slug,
            };
            window.usermaven("track", "images_created", params);
          }
          dispatch(saveSuccess(response?.data));
          setLoading(false);
          navigate(redirect);  
        })
        .catch((error) => {
          dispatch(saveFailure(getErrorMessage(error)));
          setLoading(false);
        });
    } else {
      return client
        .put(`/api/v1/images_generation/${images.id}`, { data: images.data })
        .then((response) => {
          dispatch(saveSuccess(response?.data));
          setLoading(false);
          const redirect = `/images/${response.data.id}`;
          navigate(redirect);
        })
        .catch((error) => {
          dispatch(saveFailure(getErrorMessage(error)));
          setLoading(false);
        });
    }
  };
}

export function imageArchive(images) {
  return (dispatch, getState) => {
    const client = generateApiClient(getState);
    return client
      .patch(`/api/v1/images_generation/${images.id}/archive`, {
        archived: images.archive,
      })
      .then((response) => {
        dispatch(imageArchiveSuccess(response?.data));
        dispatch(fetch());
      })
      .catch((error) => {
        dispatch(imageArchiveFailure(getErrorMessage(error)));
      });
  };
}
